<template>
  <v-card-text>
    <v-row no-gutters>
      <v-col cols="12" sm="10" offset-sm="1" v-if="error">
        <v-alert dismissible class="warning" @dismissed="onDismissed">{{ error.message }}</v-alert>
      </v-col>
      <v-col cols="12" sm="10" offset-sm="1">
        <v-text-field
          outlined
          dense
          name="email"
          label="E-Mail-Adresse"
          id="email"
          v-model="email"
          type="email"
          required></v-text-field>
      </v-col>
      <v-col cols="12" class="mt-2" sm="10" offset-sm="1">
        <v-btn block @click="onSignin()" class="primary" :disabled="$vars.loading" :loading="$vars.loading">
          Passwort Zurücksetzen
            <span slot="loader" class="custom-loader">
            <v-icon light>cached</v-icon>
            </span>
        </v-btn>          
      </v-col>
      <v-col cols="12" class="mt-2" sm="10" offset-sm="1">
        <v-btn block class="caption" text @click="onDismissed()" to="/anmelden">
          Anmelden
        </v-btn>       
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
  import { mapState } from 'vuex'
  export default {
    data () {
      return {
        email: ''
      }
    },
    computed: mapState({
      user: state => state.user.user,
      error: state => state.user.error
    }),
    watch: {
      user (value) {
        if (value !== null && value !== undefined) {
          this.$router.push('/')
        }
      }
    },
    methods: {
      onSignin () {
        let auth = this.$firebase.auth()
        let emailAddress = this.email
        auth.sendPasswordResetEmail(emailAddress).then(function () {
          console.log('Mail send')
        }).catch(function (error) {
          console.log(error)
        })
        this.$store.state.snackbar = {
          show: true,
          nachricht: 'Wenn ein Account mit dieser Mailadresse existiert, wurde eine Mail zum zurücksetzen des Passworts wurde versendet. Schau bitte auch in deinem Spam-Ordner nach.'
        }
      },
      onDismissed () {
        this.$store.dispatch('user/clearError')
      }
    }
  }
</script>

<style scoped>
.container{
  padding-left: 16px;
}
</style>



// WEBPACK FOOTER //
// updatePasswordForm.vue?cd4c54ac